/**
 *
 * Este es player controls TV para caneles CON timeshift (startover, catchup y demás)
 *
 */

import React, { Component } from 'react';
import './styles/player-controls-live-ts.css';
import ChannelInfoLabel from './common/ChannelInfoLabel';
import DirectLabel from './common/DirectLabel';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './../components/common/VideoPlayerControl';
import {
    CONTROL_RECORDING,
    CONTROL_BACKWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_EPG,
    CONTROL_LANGUAGE

} from './common/constants';

import PlayerControlsLogic from './PlayerControlsLogic';
import { AAF_CONTENT_IS_TV } from './../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import ChannelStreamUtil from '../../utils/ChannelStreamUtil';
import { playerSettings } from './common/constants';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import Translator from '../../requests/apa/Translator';
import { Grid, Row, Column, cls } from '../../packages/components';
import { seekLiveTS } from './seeks/index';
import { utilsPlayersControls } from 'src/playerDomain/components/utils/index'
import { modalInactivityPauseOnLIVE,
  modalInactivityPlayOnLIVE, updateValuesStorageMount, updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'
import LayersControl from 'src/utils/LayersControl';
import store from '../../store';


class PlayerControlsLiveTS extends Component {

    constructor(props) {
        super(props);

        this.backward = this.backward.bind(this);
        this.onExit = this.onExit.bind(this)
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.epg = this.epg.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);

        this.defaultButtons = [
            { type: CONTROL_BACKWARD, clic: this.backward, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar') },
            { type: CONTROL_PLAY, clic: this.play, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir') },
            { type: CONTROL_EPG, clic: this.epg, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_guide', 'Guía'), ref: null },
            { type: CONTROL_LANGUAGE, clic: props.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') }
        ];
        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);

        this.slide = this.slide.bind(this);
        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.setTimeshiftEventInfo = this.setTimeshiftEventInfo.bind(this);
        this.eventIsRecording = this.eventIsRecording.bind(this);

        this.seekInPause = 0;
        this.seekTime = 0;
        this.seekTotalTime = 0;
        this.currentTime = 0;

        this.state = {
            timeshiftEventInfo: null
        };

        this.switchingBetweenEventTimeshift = false;
        this.timerTimeshitDelayId = null;
        this.pendingLiveOnPause = null;
        this.timeshiftTime = 0;
        this.liveWasPause = null;
        this.waitForSeconds = false;
        // Indica que el user se esta moviendo hacía atrás
        this.backwardIsMoving = false;
        this.delayTimeshiftSeek = 1000; //ms

        this.paramsModalInactivity = {
          pause: modalInactivityPauseOnLIVE,
          play: modalInactivityPlayOnLIVE,
          exit : this.onExit,
          clearLoading: this.props.clearLoading,
          toggleEPG: this.props.onEpg,
          groupId: this.props.groupId
        }
        this.modalInactivityEnabled = store.getState().modalInactivity.enabled;
        this.setIntervalModalInactivity = this.modalInactivityEnabled ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalInactivity) : null;
    }

    onExit() {
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
      this.props.onExit()
      LayersControl.showUX()
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        this.updateCurrentTimeUI();
    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    }

    getCurrentTime() {
        return this.backwardIsMoving ? this.timeshiftTime : this.currentTime;
    }

    hasTimeshift() {
        if (this.state.timeshiftEventInfo) {
            return (this.state.timeshiftEventInfo.event && !isNaN(this.state.timeshiftEventInfo.event.max_timeshift));
        }

        return false;
    }

    useTimeshiftEvent() {
        return (
            this.hasTimeshift() &&
            this.state.timeshiftEventInfo &&
            this.state.timeshiftEventInfo.event
        );
    }

    getDuration() {
        if (this.useTimeshiftEvent()) {
            if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
                return (
                    this.state.timeshiftEventInfo.event.date_end -
                    this.state.timeshiftEventInfo.event.date_begin
                );
            }
        }

        return 0;
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;

            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI() {

        const currentTimeUI = this.getCurrentTime();
        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTimeUI, this.getDuration());

        if (this.refs['playerSlider']) {
            // % barra avance
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';
            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(currentTimeUI, AAF_CONTENT_IS_TV);
            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            // console.log('[NPC]
            // PlayerControls this.refs[playerControls].refs[timeEnd].refs[time].innerHTML',
            // this.refs['playerControls'].refs['timeEnd'].refs['time'].innerHTML);
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(this.getDuration(), AAF_CONTENT_IS_TV);
        }
    }

    /**
     * TODO revisar la condición
     */
    isRecordingEnabled() {
        return true;
    };

    /**
     * Resolve enabled buttons
     */
    getVisibleButtons() {
        const params = {
            defaultButtons : this.defaultButtons,
            timeshiftEventInfo : this.state.timeshiftEventInfo,
            addValue : {
                type: CONTROL_RECORDING,
                clic: this.props.onRecording,
                enabled: true,
                title: Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar') }
        }
        const auxDefaultButtons = this.props.addRecordingButton( params )

        const visible = auxDefaultButtons.map(
            (button) => {
                if (button.type === CONTROL_PLAY) {
                    if (this.props.playing) {
                        return { type: CONTROL_PAUSE, clic: this.pause, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_pause', 'Pausa') };
                    }
                    else {
                        // Por default el botón es play
                        return button;
                    }
                }
                else if (button.type === CONTROL_RECORDING) {
                    let buttonEnabled = null;
                    let buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                    const recordingStatus = this.props.getEventRecordingStatus();
                    const recordingButton = document.querySelector(".video-player-control-button-recording");
                    switch (recordingStatus) {
                        case 0:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 1:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 2:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_Scheduled', 'Por grabar');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 3:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_recordingBlink', 'Grabando');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 4:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_recorded', 'Grabado');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        default:
                            break;
                    }

                    return { type: CONTROL_RECORDING, clic: this.props.onRecording, enabled: buttonEnabled, title: buttonText };
                }
                else
                    return button;
            }
        );

        return visible;
    }

    addEventListeners() {
        this.removeEventListeners();
    }

    removeEventListeners() {
    }

    async componentDidMount() {
        await updateValuesStorageMount(AAF_CONTENT_IS_TV)
        this.addEventListeners();
    }

    resetLiveTimeshift() {
        this.pendingLiveOnPause = null;
        this.timeshiftTime = 0;
        this.waitForSeconds = false;
        this.backwardIsMoving = false;
    }

    componentWillUnmount() {
        this.resetLiveTimeshift();
        updateValuesStorageUnMount(this.setIntervalModalInactivity)
    }

    componentWillReceiveProps(nProps) {
        console.log('[NPC] Live cmponentWillReceiveProps ', nProps);
    }

    calculateFinalSeekTime(isBackward, seekTime) {
        seekLiveTS.calculateFinalSeekTime(isBackward, seekTime, this);
    }

    /**
   * Slider side actions
   * @param e
   */
    slide(e) {
        console.log('[NPC3] Playercontrols slide events en 1, entrando', this.props.visible, this.props.playing);
        if (!this.props.visible) {
            return false;
        }
        this.props.onSlide(null, direction);
        console.log('[NPC3] Playercontrols slide events en 2');
        const { direction } = e.detail;
        switch (direction) {
            case 'left':
                e.preventDefault();
                this.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_TV), this);
                break;
            case 'right':
                e.preventDefault();
                // Si no esta en pausa, live no se mueve hacía adelante
                if (this.pendingLiveOnPause === null) return;
                this.calculateFinalSeekTime(false, playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_TV), this);
                break;
            default:
                break;
        }
    }

    /**
        * Controles del player
        */
    play() {
        // En play no se necesita manejar el autohide
        // porque el play lanza startover
        if (!this.props.enabled) return;
        if (this.hasTimeshift()) {
            this.handleLiveWithPlay();
        }
    }

    handleLiveWithPlay() {
        const seekTo = this.timeshiftTime;
        this.props.hide();

        const timeshiftData = {
            timeshiftEvent: Object.assign({}, this.state.timeshiftEventInfo.event),
            backward: true,
            seektime: seekTo,
            maxtimeshiftallowed: this.state.timeshiftEventInfo.channelTimeshiftAllowed,
            timeshiftDelay: null
        };
        this.resetLiveTimeshift();
        utilsPlayersControls.performTimeshift(timeshiftData, this);
    }

    pause() {
        if (!this.props.enabled) return;
        this.props.pause(); // Pause player device
        if (this.hasTimeshift()) {
            this.handleLiveWithPause();
        }
        // Do extra stuff when pause device
        // onPause ya maneja el timer del autohide
        this.props.onPause(this.getCurrentTime(), () => {
            this.focus('.video-player-control-main-button-play');
        });
    }

    handleLiveWithPause() {
        // Se pone en pause el live, pero entrará en start over si es que da play el user
        if (this.props.playing) {
            this.pendingLiveOnPause = this.getCurrentTime();
            this.timeshiftTime = this.pendingLiveOnPause;
            // Ajustar esta bandera de abajo:
            // Si fue el live pausado mostramos controles y no mini epg
            // this.liveWasPause = true;
            this.backwardIsMoving = true;
        }
    }

    backward() {
        if (!this.props.enabled) return;
        this.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_TV), this);
        // Se maneja autohide en onBackward
        this.props.onBackward(null);
    }

    focus(where) {
        const resultFocus = this.props.focus(where);
        if (!resultFocus) {
            //this.focusPlayPauseButton();
        }
    }

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    getSafeTime() {
        const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

        if (timeshiftMetadata) {
            return timeshiftMetadata.start;
        }
        else {
            return 0;
        }
    }

    setOperatorsSeek(values) {
        this.valuesSeek = { ...values };
    }

    getOperatorsSeek() {
        return this.valuesSeek;
    }

    setTimeshiftEventInfo(timeshiftEventInfo) {
        this.resetLiveTimeshift();
        this.switchingBetweenEventTimeshift = false;
        /**
        * Evento a playear
        */
        let timeshiftAllowed = 0, channelNumber = '', channelImage = '', eventTitle = '';
        const groupId = timeshiftEventInfo && timeshiftEventInfo.event ? timeshiftEventInfo.event.group_id : '';
        if (groupId) {
            const channelInfo = ChannelStreamUtil.get(groupId);
            channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
            channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
            timeshiftAllowed = ChannelSingleton.getTimeshift(groupId, true);
            timeshiftEventInfo.channelTimeshiftAllowed = timeshiftAllowed;
        }
        eventTitle = timeshiftEventInfo && timeshiftEventInfo.event && timeshiftEventInfo.event.name ? timeshiftEventInfo.event.name : '';

        this.setState({ timeshiftEventInfo }, () => {
            this.updateChannelInfo(channelNumber, channelImage, eventTitle);
        });
    }

    /**
     * Update channel info
     */
    updateChannelInfo(channelNumber, channelIcon, eventTitle) {
        if (this.refs['channelInfoLabel']) {
            if (this.refs['channelInfoLabel'].refs['channelNumber']) this.refs['channelInfoLabel'].refs['channelNumber'].innerHTML = channelNumber;
            if (this.refs['channelInfoLabel'].refs['channelImageUrl']) this.refs['channelInfoLabel'].refs['channelImageUrl'].src = channelIcon;
            if (this.refs['channelInfoLabel'].refs['channelEventTitle']) this.refs['channelInfoLabel'].refs['channelEventTitle'].innerHTML = Utils.cutPlayerString(eventTitle, 30, 28);

            if(channelIcon) {
                this.refs['channelInfoLabel'].refs['channelImageUrl'] && this.refs['channelInfoLabel'].refs['channelImageUrl'].classList.remove('channel-info-label-image-hide');
            }
        }
    }

    /**
     * Clic en botón epg
     */
    epg() {
        this.props.onEpg();
    }

    eventIsRecording() {
        return this.props.eventIsRecording();
    }

    render() {
        console.log('[NPC2] PC TV render ', this.state.timeshiftEventInfo);
        const visibleButtons = this.getVisibleButtons();

        let defLength = 3;
        let controlsClassName = '';
        if(Array.isArray(visibleButtons)) {
            defLength = visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }

        let ct = 1;

        return (
            this.state.timeshiftEventInfo ?
                <div>
                    <Grid className="player-controls-live-container">
                        <Row className="player-controls-live-channelinfo-wrapper">
                            <ChannelInfoLabel ref="channelInfoLabel" />
                        </Row>

                        <Row className="player-controls-live-flex-slider-wrapper">
                            <Column lg={1} className={cls(``)}>
                                <TimeLabel ref="timeStart" />
                            </Column>
                            <Column lg={9} className={cls(``)}>
                                {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                                <PlayerSlider
                                    ref="playerSlider"
                                    withBarTotal={false}
                                    slide={this.slide}
                                    ballPercent={this.props.ballPercent}
                                />
                            </Column>
                            <Column lg={1} className={cls(``)}>
                                <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                            </Column>
                            <Column lg={1} className={cls(``)}>
                                <DirectLabel type="aaf_content_is_tv" label={Translator.get('playingLive_eventType_description_presentEvent_label', 'AHORA')} />
                            </Column>
                        </Row>
                        <Row>
                            <div className="player-controls-live-separator"></div>
                        </Row>
                        </Grid>
                        <Grid className={cls(`player-controls-live-no-grid-float`)}>
                            <Row className={cls(`player-controls-live-flex-controls-wrapper ${controlsClassName}`)}>
                                {
                                    visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                        control={button}
                                        onClic={button.clic}
                                        key={`control_${ct++}`}
                                        id={`pc${idx}`}
                                        nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                                    />
                                    )
                                }
                            </Row>
                      </Grid>
                </div>
                :
                <div className="player-controls-live-container"></div>
        )
    }
}

export default PlayerControlsLiveTS;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsLiveTS.js